// extracted by mini-css-extract-plugin
export var md = "_1n-4";
export var semantic = "_1n-5";
export var sm = "_1n-3";
export var text = "_1n-6";
export var toggleInput = "_1n-0";
export var toggleSwitch = "_1n-1";
export var xs = "_1n-2";